import {AppStartListening} from '@/redux/store/listenerMiddleware';
import scheduleTrackerRequestsService from '@/services/scheduleTrackerService';

import {
    getScheduleTrackerRequestsCount,
    getScheduleTrackerRequestsCountError,
    getScheduleTrackerRequestsCountSuccess,
} from './slice';

const addFeatureListeners = (startListening: AppStartListening) => {
    startListening({
        actionCreator: getScheduleTrackerRequestsCount,
        effect: async (_action, listenerApi) => {
            try {
                const respData = await scheduleTrackerRequestsService.getScheduleTrackerRequestsCount();
                listenerApi.dispatch(getScheduleTrackerRequestsCountSuccess(respData?.count));
            } catch (error) {
                listenerApi.dispatch(getScheduleTrackerRequestsCountError());
                console.error('Get schedule tracker requests count failed');
            }
        },
    });
};

export default addFeatureListeners;
